export default "__VITE_ASSET__U9dwf861__"